<template>
  <div>
    <div
      v-for="(item, index) of hospitalList"
      :key="index"
      class="mt-cell d-flex p-2"
      @click="handleClick(item)">
      <img
        v-if="item.id === $store.state.fuyiHospitalId || item.id === 6"
        slot="icon"
        src="@/assets/fuyi.jpg"
        width="35"
        height="35"
        class="align-self-center">
      <img
        v-if="item.id === $store.state.zhongxiHospitalId"
        slot="icon"
        src="@/assets/zhongxin.jpg"
        width="35"
        height="35"
        class="align-self-center">
      <span
        class="align-self-center mr-auto hospital-name">{{ item.name }}</span>
      <span
        class="align-self-center"> <i class="fas fa-angle-right gray"/></span>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'ChooseHospital',
  data() {
    return {
      hospitalList: [], // 医院信息列表
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * 获取医院信息
     */
    async init() {
      const url = '/patient-api/webapi/information/get-hospital-by-ids';
      const params = {
        ids: '2,3,6',
      };
      const headers = {
        Authorization: Cookies.get('token'),
      };
      const response = await this.$http.get(url, { params, headers });
      this.hospitalList.push(...response);
    },
    /**
     * 路由跳转
     */
    handleClick(params) {
      // 存储医院信息
      const hospitalInfor = {
        address: params.address,
        level_code: params.level_code,
        name: params.name,
      };
      window.sessionStorage.setItem('hospital', JSON.stringify(hospitalInfor));
      this.$router.push({ name: 'ChooseRoom', query: { hospitalId: params.id } });
    },
  },
};
</script>

<style scoped>
  .mt-cell {
    background: #fff;
    border-bottom: 1px solid #F0F0F0;
    line-height: 52px;
  }
  .hospital-name{
    padding-left: 10px;
  }
  .gray {
    color: #cfcfcf;
  }
</style>



// WEBPACK FOOTER //
// src/views/appointment/select-hospital.vue